import presenceTypes from '../constants/presenceTypes';

const getFriendsInGame = (friendsPresenceData, currentUniverseId) => {
  const userIdsInUniverses = [];
  if (friendsPresenceData?.length) {
    friendsPresenceData.forEach(friendPresence => {
      if (friendPresence?.presence) {
        const { universeId, userId } = friendPresence.presence;
        if (
          universeId === currentUniverseId &&
          friendPresence?.presence?.userPresenceType === presenceTypes.ingame.status
        ) {
          userIdsInUniverses.push(userId);
        }
      }
    });
  }
  return userIdsInUniverses;
};

const getPresencesUpdateData = (
  presencesData,
  currentFriendsData,
  currentFriendsInGame,
  universeId
) => {
  if (!presencesData?.length || !currentFriendsData?.length) {
    return null;
  }
  let isFriendsDataUpdated = false;
  presencesData.forEach(presence => {
    const { userId, universeId: currentPlayUniverseId, userPresenceType } = presence;

    if (
      currentPlayUniverseId === universeId &&
      userPresenceType === presenceTypes.ingame.status &&
      currentFriendsInGame.indexOf(userId) < 0
    ) {
      // user in game but not appear in game tile yet
      isFriendsDataUpdated = true;

      currentFriendsData.forEach(friend => {
        const currentFriend = friend;
        if (userId === friend.id) {
          currentFriend.presence = presence;
        }
      });
    } else if (
      userPresenceType !== presenceTypes.ingame.status &&
      currentFriendsInGame.indexOf(userId) > -1
    ) {
      // user was in game
      isFriendsDataUpdated = true;

      currentFriendsData.forEach(friend => {
        const currentFriend = friend;
        if (userId === friend.id) {
          currentFriend.presence = presence;
        }
      });
    }
  });

  if (isFriendsDataUpdated) {
    return currentFriendsData;
  }

  return null;
};

export default {
  getFriendsInGame,
  getPresencesUpdateData
};
